<template>
  <div class="mini-bio">
    <div class="mini-bio__header">
      <z-text
        class="mini-bio__header-title"
      >
        Conheça o autor
      </z-text>
    </div>

    <div class="mini-bio__author">
      <div class="mini-bio__avatar">
        <z-avatar
          v-if="authorImage"
          aria-label="Imagem do autor"
          size="large"
          :src="authorImage"
        />

        <z-avatar
          v-else-if="!authorImage"
          aria-label="Imagem do autor"
          size="large"
        />
      </div>

      <div class="mini-bio__author-text">
        <z-text
          class="mini-bio__author-written-by"
          color="minor"
        >
          Escrito por:
        </z-text>

        <div class="mini-bio__author-name">
          <z-text
            v-if="authorName"
            class="mini-bio__author-name-text"
          >
            {{ authorName }}
          </z-text>
        </div>
      </div>
    </div>

    <z-dynamic-content
      class="mini-bio__author-biography"
      :class="{
        'mini-bio__author-biography--expanded': expanded,
        'mini-bio__author-biography--has-fade': !expanded && shouldShowReadMore
      }"
      tag="div"
    >
      <div
        ref="biographyText"
        class="mini-bio__author-biography-text"
        :class="{ 'mini-bio__author-biography-text--collapsed': !expanded && shouldShowReadMore }"
        v-html="authorBiography"
      />
    </z-dynamic-content>

    <div
      v-if="!expanded && shouldShowReadMore"
      class="mini-bio__footer"
    >
      <z-button
        class="mini-bio__footer-button"
        variant="tertiary"
        @click="expandText"
      >
        Ler mais

        <z-icon
          size="medium"
          :icon="['fas', 'chevron-down']"
        />
      </z-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiniBio',
  props: {
    authorName: {
      type: String,
      default: '',
    },
    authorBiography: {
      type: String,
      default: '',
    },
    authorImage: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      expanded: false,
      shouldShowReadMore: false,
    }
  },
  mounted () {
    this.$nextTick(() => {
      const biographyTextElement = this.$refs.biographyText

      if (biographyTextElement) {
        const originalMaxHeight = biographyTextElement.style.maxHeight

        biographyTextElement.classList.add('mini-bio__author-biography-text--collapsed')
        const collapsedHeight = biographyTextElement.offsetHeight

        biographyTextElement.classList.remove('mini-bio__author-biography-text--collapsed')
        const fullHeight = biographyTextElement.scrollHeight

        biographyTextElement.style.maxHeight = originalMaxHeight

        this.shouldShowReadMore = fullHeight > collapsedHeight
      }
    })
  },
  methods: {
    expandText () {
      this.expanded = true
    },
  },
}
</script>

<style lang="scss" scoped>
.mini-bio {
  padding: var(--unit-1000) var(--unit-0400);

  &__header {
    padding-bottom: var(--unit-0600);

    &-title {
      font-weight: 700;
      font-size: var(--unit-0500);
    }
  }

  &__author {
    display: flex;

    &-written-by {
      font-size: var(--unit-0300);
      margin-bottom: var(--unit-0100);
      text-transform: uppercase;
    }

    &-name-text {
      font-weight: 700;
      font-size: var(--unit-0400);
    }
  }

  &__avatar {
    margin-right: var(--unit-0400);
  }

  &__author-biography {
    padding: var(--unit-0400) 0;
    position: relative;

    @media (min-width: $breakpoint-desktop) {
      padding-left: var(--unit-2000);
      padding-top: var(--unit-0100);
    }

    &.mini-bio__author-biography--has-fade::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 4em;
      background: linear-gradient(to bottom, rgba(246, 247, 248, 0) 0%, rgba(246, 247, 248, 1) 100%);
      pointer-events: none;
    }
  }

  &__author-biography-text {
    transition: max-height 0.3s ease-out;

    &--collapsed {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }

  &__footer-button {
    width: 100%;
  }
}

.mini-bio__author-text {
  display: flex;
  flex-direction: column;
}
</style>
